import Icon from 'veui/components/Icon'

Icon.register({
  ellipsis: {
    paths: [
      {
        d: 'M42.2 27.59a3.8 3.8 0 110-7.59 3.8 3.8 0 010 7.59zm-18.2 0A3.8 3.8 0 1124 20a3.8 3.8 0 010 7.59zm-18.2 0a3.8 3.8 0 110-7.59 3.8 3.8 0 010 7.59z',
        'fill-rule': 'evenodd'
      }
    ],
    width: '48',
    height: '48'
  }
})
